import React from 'react';
import ReactDOM from 'react-dom/client';

import '@/polyfills/arraySorted';
import App from '@/layouts/App';
import { unregisterLegacyPushWorker } from '@/helpers';

const isDevelopment = import.meta.env.MODE === 'development';

// One-off cleanup after removing Firebase push — delete once old installs have cycled out
unregisterLegacyPushWorker();

ReactDOM.createRoot(document.getElementById('root')!).render(
  isDevelopment ? (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  ) : (
    <App />
  )
);
